import Vue from 'vue';

const storage = {};

const setStorage = (name, value) => {
  storage[name] = value;
};

const getStorage = name => storage[name];

/**
 * 返回请求的req和data
 * @param name
 * @param options
 */
export const getRequestDataReq = (pageConfig, name, options) => {
  let data;
  const req = getRealRequest(pageConfig, name, options);

  switch (true) {
    case Vue.prototype.inMagic:
    case Vue.prototype.inPrerender:
      data = {};
      break;
    case !!!name:
    case !!!(req?.options):
      data = false;
      break;
    case typeof name === 'string':
      data = getStorage(name);
      break;
    case !!(req.isMock && req.mockData):
      data = req.mockData;
      break;
    default:
  }

  return {
    data,
    req,
  };
};

const getRequest = ({ requests }, name, options = {}) => {
  const reqs = requests?.filter(req => req.name === name);

  if (reqs?.length) {
    const req = {
      ...reqs[0],
    };

    const reqOptions = req.options;
    if (reqOptions.type !== 'POST' && reqOptions.params) {
      reqOptions.params = Object.assign({}, reqOptions.params, options);
    } else {
      reqOptions.data = Object.assign({}, reqOptions.data, options);
    }

    req.options = reqOptions;

    return req;
  }
};

/**
 * 返回请求的request对象
 * @param name
 * @param options
 * @returns {null|{options: *}|*|{}}
 */
const getRealRequest = (pageConfig = {}, name, options) => {
  if (typeof name === 'string') {
    return getRequest(pageConfig, name, options);
  }
  if (typeof name === 'object') {
    return {
      options: name,
    };
  }
  return null;
};

// 有海外版标记时，请求要加上 platform
const platformCheck = (request) => {
  const req = request;
  if (Vue.prototype.isOverseasVer) {
    const platform = Vue.prototype.env.isIos ? 5 : 3;
    if (req.options.params && typeof req.options.params === 'object') {
      req.options.params.platform = platform;
    }
    if (req.options.data && typeof req.options.data === 'object') {
      req.options.data.platform = platform;
    }
  }
  return req;
};

/**
 * 处理错误信息
 * @param errorCode
 * @param data
 */
const reqErrorCodeHandler = (errorCode, data) => {
  if (data.ret === -104) {
    // 调用敏感接口鉴权不通过，需要使用会员登录态重新登录
    if (typeof Vue.prototype.$magicLogin.switchLogin === 'function') {
      Vue.prototype.$magicLogin.switchLogin({ code: -104, msg: '调用敏感接口鉴权不通过，需要使用会员登录态重新登录' });
    }

    throw new Error('调用敏感接口鉴权不通过，需要使用会员登录态重新登录');
  }

  if (data.ret === -1041 && data.magic_ret === -1041) {
    Vue.prototype.toast(data.msg);
  }

  if (errorCode?.length) {
    const err = errorCode.filter(error => +error.code === +(data.ret || data.code));
    if (err.length) {
      Vue.prototype.toast(err[0].msg);
    }
  }
};

export const request = async (req) => {
  let data;
  // eslint-disable-next-line
  req = platformCheck(req.options ? req : {
    options: req,
  });

  try {
    const { $magicRequest, fetch } = Vue.prototype;
    if (typeof $magicRequest?.beforeMagicRequest === 'function') {
      // eslint-disable-next-line
      req = await $magicRequest?.beforeMagicRequest(req);
    }
    data = await fetch.request(req.options);
    if (typeof $magicRequest?.afterMagicResponse === 'function') {
      data = await $magicRequest?.afterMagicResponse(data, req);
    }
    if (req.cache && typeof name === 'string') {
      setStorage(name, data);
    }
  } catch (e) {
    console.dir(e);
    if (e && e.message === 'Network Error') {
      Vue.prototype.toast('网络异常，请稍后重试');
      throw e;
    }
    throw e;
  }

  reqErrorCodeHandler(req.errorCode, data);

  return data;
};
